import { OrderStart } from "../../types/order-form";

export const GetOrderStart =
  (response: OrderStart) => async (dispatch: any) => {
    try {
      dispatch({ type: "GET_ORDER_START_SUCCESS", payload: response });
    } catch (error) {
      console.log("error GetOrderStart", error);
    }
  };
